<template>
    <component :is="currentIcon" />
</template>

<script setup lang="ts">
    import IconAdd from './Icons/IconAdd.vue';
    import IconArrow from './Icons/IconArrow.vue';
    import IconCheck from './Icons/IconCheck.vue';
    import IconDescribedVideo from './Icons/IconDescribedVideo.vue';
    import IconErase from './Icons/IconErase.vue';
    import IconFilter from './Icons/IconFilter.vue';
    import IconLabelDv from './Icons/IconLabelDv.vue';
    import IconLock from './Icons/IconLock.vue';
    import IconNoPerson from './Icons/IconNoPerson.vue';
    import IconNoPicture from './Icons/IconNoPicture.vue';
    import IconNotSupported from './Icons/IconNotSupported.vue';
    import IconPlay from './Icons/IconPlay.vue';
    import IconRestart from './Icons/IconRestart.vue';
    import IconScrollbar from './Icons/IconScrollbar.vue';
    import IconSearch from './Icons/IconSearch.vue';
    import IconShowAll from './Icons/IconShowAll.vue';
    import IconStar from './Icons/IconStar.vue';
    import IconTrailer from './Icons/IconTrailer.vue';
    import IconTv from './Icons/IconTv.vue';

    const props = defineProps<{
    iconName: string;
    }>();

    const icons: Record<string, ReturnType<typeof defineComponent>> = {
        IconAdd,
        IconArrow,
        IconCheck,
        IconDescribedVideo,
        IconErase,
        IconFilter,
        IconLabelDv,
        IconLock,
        IconNoPerson,
        IconNoPicture,
        IconNotSupported,
        IconPlay,
        IconRestart,
        IconScrollbar,
        IconSearch,
        IconShowAll,
        IconStar,
        IconTrailer,
        IconTv
    };

    const currentIcon = computed(() => {
        return icons[props.iconName];
    });
</script>
